export const LQOdata = {

    LQOdata_fr:{
        title: "Découvrez Quartier Oviv",
        subtitle: "Le projet le plus ambitieux de SIMDEV à Charlemagne",
        paragraph_1: "Situé en bordure de la rivière des Prairies, Quartier Oviv se démarque par son envergure et sa vision. Avec 1236 unités réparties sur 7 phases, des bâtiments variant de 12 à 30 étages et deux stationnements souterrains, il devient le plus grand projet résidentiel locatif à l’est de Montréal.",
        paragraph_2: {
            title: "Destination Charlemagne",
            text: "Pensé pour offrir une qualité de vie exceptionnelle, Quartier Oviv proposera une combinaison harmonieuse de condos locatifs, de condos à vendre et de commerces de proximité, créant ainsi un milieu de vie complet, dynamique et à échelle humaine.",
            button: "Découvrez"
        },
        phase_1: {
            title: "Le début d’une nouvelle ère",
            subtitle: "Phase 1",
            text: "Lancée en janvier 2025, la Phase 1 comprendra 144 condos locatifs répartis dans un immeuble moderne de 12 étages. La livraison est prévue pour juin 2026.",
            button: "Découvrez"
        },
        features: {
            title: "Un engagement concret pour un avenir durable",
            keypoints: {
                keypoint1: "Récupération de la chaleur pour le chauffage de l’eau",
                keypoint2: "Optimisation énergétique des systèmes mécaniques",
                keypoint3: "Collecte des eaux de pluie pour l’irrigation des espaces verts",
                keypoint4: "Utilisation de gaz naturel renouvelable",
                keypoint5: "Conception et orientation réfléchies pour maximiser le confort des résidents",
            },
            conclusion: "L’intégration harmonieuse du projet dans son environnement naturel reflète notre engagement à créer un lieu de vie où bien-être et écoresponsabilité coexistent naturellement."
        },
        vision: {
            alt_title: "SIMDEV : Une vision intégrée",
            title: "SIMDEV",
            subtitle: "Une vision intégrée",
            text: "Chez SIMDEV, nous portons l’ambition de devenir un développeur intégré capable de concevoir, construire et opérer chacun de nos projets sous un même toit, avec passion, responsabilité et engagement.",
            button: "Notre histoire"
        },
        metadata: {
            total_units: 1236,
            total_phases: 7,
            building_heights: "12 à 30 étage",
            underground_parking: 2,
            location: "Charlemagne, QC",
            region: "Est de Montréal"
        }
    },
    LQOdata_en: {
        title: "Discover Quartier Oviv",
        subtitle: "SIMDEV's most ambitious project in Charlemagne",
        paragraph_1: "Located on the banks of the Rivière des Prairies, Quartier Oviv stands out for its scale and vision. With 1,236 units spread across 7 phases, buildings ranging from 12 to 30 stories, and two underground parking garages, it is the largest rental residential project in the east end of Montreal.",
        paragraph_2: {
            title: "Welcome to Charlemagne",
            text: "Designed to offer an exceptional quality of life, Quartier Oviv will feature a harmonious mix of rental condos, condos for sale, and local shops — creating a complete, dynamic, and human-scale living environment.",
            button: "Discover"
        },
        phase_1: {
            title: "The Beginning of a New Era",
            subtitle: "Phase 1",
            text: "Launched in January 2025, Phase 1 will include 144 rental condos in a modern 12-story building. Delivery is scheduled for June 2026.",
            button: "Discover"
        },
        features: {
            title: "A Concrete Commitment to a Sustainable Future",
            keypoints: {
                keypoint1: "Heat recovery for water heating",
                keypoint2: "Energy optimization of mechanical systems",
                keypoint3: "Rainwater collection for green space irrigation",
                keypoint4: "Use of renewable natural gas",
                keypoint5: "Thoughtful design and orientation to maximize resident comfort"
            },
            conclusion: "The harmonious integration of the project into its natural environment reflects our commitment to creating a place where well-being and environmental responsibility coexist naturally."
        },
        vision: {
            alt_title: "SIMDEV: An Integrated Vision",
            title: "SIMDEV",
            subtitle: "An Integrated Vision",
            text: "At SIMDEV, we aim to become a fully integrated developer capable of designing, building, and operating each of our projects under one roof—with passion, responsibility, and commitment.",
            button: "Our history"
        },
        metadata: {
            total_units: 1236,
            total_phases: 7,
            building_heights: "12 to 30 stories",
            underground_parking: 2,
            location: "Charlemagne, QC",
            region: "East of Montreal"
        }
    }
}